import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="py-32 px-6 md:px-12 bg-neutral-900" id="about" data-id="element-7">
      <div className="max-w-5xl mx-auto" data-id="element-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-9">
          {/* Content */}
          <motion.div className="lg:col-span-7" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-10">
            <p className="text-amber-500 uppercase tracking-[0.2em] text-xs font-medium mb-6" data-id="element-11">
              Our Heritage
            </p>
            <h2 className="text-4xl md:text-6xl font-serif text-stone-50 mb-10 leading-tight" data-id="element-12">
              About Freddie & <br data-id="element-13" />
              The Family
            </h2>

            <div className="space-y-8 text-lg text-stone-400 font-light leading-relaxed" data-id="element-14">
              <p data-id="element-15">
                For years, the Cheah family has been dedicated to bringing
                exceptional dining experiences to the heart of Paducah,
                Kentucky. What started as a simple passion for great food and
                community has blossomed into a family of distinct restaurants.
              </p>
              <p data-id="element-16">
                Freddie Cheah believed that a restaurant should be more than
                just a place to eat—it should be a gathering place where
                memories are made, milestones are celebrated, and everyone is
                treated like family.
              </p>
              <p data-id="element-17">
                Today, whether you're enjoying a perfectly seared steak at{' '}
                <span className="text-stone-200 font-medium" data-id="element-18">Grilled 211</span>,
                sharing a slice at{' '}
                <span className="text-stone-200 font-medium" data-id="element-19">
                  Pizza Warehouse
                </span>
                , or sitting down for a classic meal at{' '}
                <span className="text-stone-200 font-medium" data-id="element-20">
                  Freddy Cheah's
                </span>
                , you'll experience the same commitment to quality ingredients,
                warm hospitality, and community spirit that started it all.
              </p>
              <p className="text-xl font-serif text-stone-200 pt-6 italic" data-id="element-21">
                Welcome to our table. We're glad you're here.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div className="lg:col-span-5 relative" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} data-id="element-22">
            <div className="aspect-[3/4] overflow-hidden relative" data-id="element-23">
              <img src="https://images.unsplash.com/photo-1583394838336-acd977736f90?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Chef preparing food" className="w-full h-full object-cover grayscale opacity-80 mix-blend-luminosity" data-id="element-24" />
              <div className="absolute inset-0 bg-neutral-900/40" data-id="element-25"></div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-amber-500/30 z-[-1]" data-id="element-26"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 border border-amber-500/30 z-[-1]" data-id="element-27"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}